import { fetchDictionaries } from './repository'

const state = {
  activeLang: 'eng',
  teamNameMap: {}
}

/** @type {Record<string, Record<string, string>>} */
const dictionaryLookup = {
  /* [langId]: dictionary */
}

const _getTeamNameMap = () => state.teamNameMap

const _setActiveLang = (newActiveLang = 'eng') => (state.activeLang = newActiveLang)

export const initLocalization = async (langId = '') => {
  try {
    _setActiveLang(langId)

    if (!dictionaryLookup[langId]) {
      dictionaryLookup[langId] = {}
    }

    const { dictionary, teamNameMap } = await fetchDictionaries(langId)

    extendDictionary(dictionary, langId)
    extendTeamNameMap(teamNameMap)
  } catch {
    console.log('Failed to initialize localization')
  }
}

export const loc = (key = '', langId = state.activeLang) => dictionaryLookup?.[langId]?.[key] || key

// export const loc = (key = '', langId = state.activeLang) => {
//   const keyParts = key.split(' ') || []
//
//   if (keyParts.length === 1) {
//     return dictionaryLookup?.[langId]?.[key] || key
//   }
//
//   return keyParts.reduce((localizedLabel, currentPart) => {
//     const localizedPart = dictionaryLookup?.[langId]?.[currentPart] || currentPart
//     return localizedLabel ? `${localizedLabel} ${localizedPart}` : localizedPart
//   }, '')
// }

export const localizeTeamName = (teamId = '', defaultValue = '', langId = state.activeLang) => _getTeamNameMap()[teamId]?.[langId] || defaultValue

export const extendDictionary = (additionalDdictionary = {}, langId = state.activeLang) => {
  if (!dictionaryLookup[langId]) {
    dictionaryLookup[langId] = {}
  }

  for (const dictKey in additionalDdictionary) {
    if (!dictionaryLookup[langId][dictKey]) {
      dictionaryLookup[langId][dictKey] = additionalDdictionary[dictKey]
    }
  }
}

export const extendTeamNameMap = (additionalTeamName = {}) => {
  for (const dictKey in additionalTeamName) {
    state.teamNameMap[dictKey] = additionalTeamName[dictKey]
  }
}
